// extracted by mini-css-extract-plugin
export var text = "copyright-module--text--bqf00";
export var bold = "copyright-module--bold--eFN1a";